/* eslint-disable no-param-reassign */
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

// Canonical CSV column labels for export and import round-trip (PCS-11321).
// The export modal's attribute picker and the import wizard's auto-mapping
// both consume GET /products/csvSchema so collision suffixes stay in sync.
export const resetCsvSchema = createAction('products/resetCsvSchema');

export const getCsvSchema = createAsyncThunk(
  'products/getCsvSchema',
  async (_, { extra: { sdk, Logger } }) => {
    try {
      const { data } = await sdk.products.getCsvSchema();
      return data;
    } catch (error) {
      Logger.error(new Error('Error fetching products CSV schema'), { error }, [
        'ProductsGetCsvSchemaFailed',
        { errorMessage: error?.message || 'NoMessage' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder
    .addCase(resetCsvSchema, (state) => {
      state.csvSchema.isLoaded = false;
      state.csvSchema.isLoading = false;
      state.csvSchema.columns = [];
      state.csvSchema.error = null;
    })
    .addCase(getCsvSchema.pending, (state) => {
      state.csvSchema.isLoading = true;
    })
    .addCase(getCsvSchema.fulfilled, (state, { payload }) => {
      state.csvSchema.isLoading = false;
      state.csvSchema.isLoaded = true;
      state.csvSchema.columns = payload.columns || [];
      state.csvSchema.error = null;
    })
    .addCase(getCsvSchema.rejected, (state, { error }) => {
      state.csvSchema.isLoading = false;
      // Finished (failed) — otherwise !isLoaded && !isLoading retriggers forever.
      state.csvSchema.isLoaded = true;
      state.csvSchema.error = error;
    });
};
